import { render, staticRenderFns } from "./PictureGroup.vue?vue&type=template&id=6ad78c93&"
import script from "./PictureGroup.vue?vue&type=script&lang=js&"
export * from "./PictureGroup.vue?vue&type=script&lang=js&"
import style0 from "./PictureGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports